<div class="padding-top footerblock bg_black">
  <div class="container">
    <div class="row">
      <div class="col-md-4 col-sm-12 footer_column">
        <h4 class="heading">Horaires d'ouverture</h4>
        <hr class="half_space" />
        <div *ngIf="pdv?.openingtext" [innerHtml]="pdv?.openingtext" class="comment"></div>
      </div>
      <div class="col-md-4 col-sm-12 footer_column">
        <h4 class="heading">Zones de livraison:</h4>
        <hr class="half_space" />
        <div *ngIf="authorizedCities.length == 0">
          Aucune zone de livraison disponible.
        </div>
        <table class="table-striped zones" *ngIf="authorizedCities.length > 0">
          <thead>
            <tr>
              <th>Zone</th>
              <th>Min de cmd</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let zone of authorizedCities; let i = index">
              <tr [hidden]="i > 6 && !displayAll">
                <td>
                  <a href="/commander/livraison-{{pdv.speciality}}-{{ zone.name | lowercase }}-{{
                      zone.postalCode
                    }}" title="livraison {{ zone.name }} {{ zone.postalCode }}">{{ zone.name }}
                    {{ zone.postalCode }}</a>
                </td>
                <td class="text-center">{{ zone.amountMiniDelivery }}€</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <button class="btn more" *ngIf="authorizedCities.length > 7" (click)="displayAll = !displayAll">
          Voir
          <ng-container *ngIf="!displayAll">
            plus ...
          </ng-container>
          <ng-container *ngIf="displayAll">
            moins ...
          </ng-container>
        </button>
      </div>
      <div class="col-md-4 col-sm-12 footer_column contact">
        <h4 class="heading">Contact</h4>
        <hr class="half_space" />
        <p class="address">
          <i class="flaticon-pin"></i>
          <a #maplink href="#" target="_blank"> {{ pdv?.address }}</a>
        </p>
        <p class="phone">
          <i class="flaticon-phone-on-circle"></i>
          <a href="tel:{{ pdv?.phone }}">{{ pdv?.phone }}</a>
        </p>
        <p class="email" *ngIf="pdv?.emailContact">
          <i class="flaticon-arroba"></i>
          <a href="mailto:{{ pdv?.emailContact }}">
            {{ pdv?.emailContact }}
          </a>
        </p>
        <p class="email" *ngIf="pdv?.facebook">
          <i class="flaticon-facebook"></i>
          <a href="{{ pdv?.facebook }}" target="_blank" class="facebook">
            Contactez-nous sur facebook
          </a>
        </p>
        <p class="email" *ngIf="pdv?.instagram">
          <i class="flaticon-picture"></i>
          <a href="{{ pdv?.instagram }}" target="_blank" class="instagram">
            Suivez-nous sur instagram
          </a>
        </p>
        <p class="email" *ngIf="pdv?.snapchat">
          <i class="flaticon-snapchat"></i>
          <a href="{{ pdv?.snapchat }}" target="_blank" class="snapchat">
            Snapchat
          </a>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 copyright">
        <div class="row">
          <div class="col-md-6">
            <div class="clearfix">
              <p>
                Copyright © {{currentYear}}
                <a class="helpyfood" href="http://www.helpyfood.com" target="_blank">Helpyfood</a>. Tous droits réservés
              </p>
            </div>
          </div>
          <div class="col-md-6">
            <ul class="cgv-links pull-right">
              <li>
                <a [routerLink]="'/cgv'" target="_blank" rel="noopener noreferrer">CGV</a>
              </li>
              <li>
                <a [routerLink]="'/mentions-légales'" target="_blank" rel="noopener noreferrer">Mentions légales</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="footerLinks" *ngIf="authorizedCities.length > 0 && families.length > 0" style="display: none;">
  <div class="text-center mb-2">
    <ng-container *ngFor="let family of families">
      <ng-container *ngFor="let zone of authorizedCities">
        <a routerLink="/commander/livraison-{{family.slug}}-{{zone.name|lowercase}}-{{ zone.postalCode }}">
          commander {{family.label|titlecase}} à {{zone.name|titlecase}} {{ zone.postalCode }} |
        </a>
      </ng-container>
    </ng-container>
  </div>
  <div class="text-center mb-2">
    <ng-container *ngFor="let family of families">
      <ng-container *ngFor="let zone of authorizedCities">
          <a routerLink="/restaurant-{{family.slug}}-{{zone.name|lowercase}}-{{ zone.postalCode }}">
            {{family.label|titlecase}} {{zone.name|titlecase}} {{ zone.postalCode }} |
          </a>
      </ng-container>
    </ng-container>
  </div>
  <div class="text-center mb-2">
    <ng-container *ngFor="let family of families">
      <ng-container *ngFor="let zone of authorizedCities">
        <a routerLink="/restaurant-livraison-{{family.slug}}-{{zone.name|lowercase}}-{{ zone.postalCode }}">
          Livraison {{family.label|titlecase}} {{zone.name|titlecase}} {{ zone.postalCode }} |
        </a>
      </ng-container>
    </ng-container>
  </div>
</div>